import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { getMenuData } from "../slices/auth/menu/thunk";

const Navdata = () => {
	const dispatch = useDispatch();

	// Menu Data
	const [menuItems, setMenuItems] = useState([]);
	const selectMenuData = createSelector((state) => state.MenuData, (state) => state)
	const menuData = useSelector(selectMenuData);

	useEffect(() => {
		if (menuData.client !== null) {
			setMenuItems(menuData.client.clients);
		}
	}, [menuData]);


	return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;